

<template>
    <v-container fluid class="px-0 py-0">
        <v-flex xs12 class="px-0 py-0">
            <v-toolbar :color="colorpick" dark flat>
                <v-toolbar-title :style="$store.state.textFormatting.headers">
                    Alerts Over Time 
                    <span v-if="overarching_type=='user'"> - {{ username }} </span>
                    <span v-if="overarching_type=='organisation'"> - {{ organisation }} </span>
                    <span v-if="!allow_popped"> <small> (only shows live alerts) </small> </span>
                </v-toolbar-title>
                <v-spacer />
                <v-btn @click="showbubble=!showbubble" class="mx-2" small fab color="blue" dark v-if="!showbubble"> <h2> + </h2> </v-btn>
                <v-btn @click="showbubble=!showbubble" class="mx-2" small fab color="blue" dark v-if="showbubble"> <h2> - </h2> </v-btn>
                <info>
                    <template slot>
                        Alerts over time bubble graph
                    </template>
                    <template slot="body">
                        <p> Displays selected alerts, colour coded by prefix/ ASN of interest to your organisation/ user. </p>
                        <p> The 'Y' axis is the hijack score of the alert, with the size representing the event count in the selected alert (i.e. how many events have occured with the same base attributes in that 5 minute period). </p>
                        <p> Click on a bubble to bring up the alert in a table below. </p>
                        <p> This can then be clicked to bring up the alert details page. </p>
                    </template>
                </info>
            </v-toolbar>
            <v-card v-if="bubbleData&&showbubble">
                <v-layout justify-center align-center>
                    <v-flex class="px-8 py-2 text-xs-center">
                        <bubbleGraph style="height:30vh" :chart-data="bubbleData"  :options="options" :key="id"> </bubbleGraph>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card v-if="bubble_alert&&showbubble">
                <v-card-text>
                    <v-flex>
                    <v-data-table
                        :headers="bubbleHeaders"
                        :items="bubble_alert"
                        :key="id"
                        hide-actions
                    >
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip top eager>
                            <span slot="activator" :style="$store.state.textFormatting.main">
                                <div v-for="line in props.header.text" :key="line.index">
                                    <div> {{ line }} </div>
                                </div>
                            </span>
                            <span :style="$store.state.textFormatting.main">
                                {{ props.header.ad_text }}
                            </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                        <tr>

                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.alert_type }}</td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.prefix }}</td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.non_direct_prefix }}</td>
                            <td @click="clickHandleAlert(props.item)"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                </v-tooltip>
                                <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                            </td>

                            <td @click="clickHandleAlert(props.item)"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                </v-tooltip>
                                <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                            </td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.asn_of_interest }}</td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.hijack_score_mean }}</td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.impact_score_mean }}</td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >
                            <v-chip
                                :color="getColor(props.item.interval_start.date)"
                                text-color="#000000"
                                dark
                                :style="$store.state.textFormatting.main"
                            >{{ props.item.interval_start.date }}</v-chip>
                            </td>
                            <td
                            @click="clickHandleAlert(props.item)"
                            class="text-xs-center"
                            :style="$store.state.textFormatting.main"
                            >{{ props.item.interval_start.time }}</td>
                        </tr>
                        </template>
                    </v-data-table>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-flex>


        <v-flex xs12 class="px-0 py-2" shrink v-if="overarching_type=='organisation'&&org_bonus_alerts.length>0">
            <v-card color="accent">
                    <v-layout align-center justify-center>
                        <v-flex shrink class="px-1 py-1">
                            <h1> {{ org_bonus_alerts.length }} new alerts, click here to merge -> </h1>
                        </v-flex>
                        <v-spacer />
                        <v-flex shrink class="px-1 py-1">
                            <v-btn :style="$store.state.textFormatting.main" color="success" rounded small dark @click="mergeAlerts('organisation')">merge</v-btn>
                        </v-flex>
                    </v-layout>
            </v-card>
        </v-flex>

        <v-flex xs12 class="px-0 py-2" shrink v-if="overarching_type=='user'&&user_bonus_alerts.length>0">
            <v-card color="secondary">
                    <v-layout align-center justify-center>
                        <v-flex shrink class="px-1 py-1">
                            <h1 :style="$store.state.textFormatting.headers" style="color:white;"> {{ user_bonus_alerts.length }} new alerts, click here to merge -> </h1>
                        </v-flex>
                        <v-spacer />
                        <v-switch slot="activator" v-model="autoMerge">
                            <template v-slot:label>
                                <div :style="$store.state.textFormatting.main" style="color:white;">Automatically merge alerts when pulled via <b>'Live Updates'</b></div>
                            </template>
                        </v-switch>
                        <v-flex shrink class="px-1 py-1">
                            <v-btn :style="$store.state.textFormatting.main" color="success" rounded small dark @click="mergeAlerts('user')">merge</v-btn>
                        </v-flex>
                    </v-layout>
            </v-card>
        </v-flex>
                    

        <v-flex xs12 class="py-3 px-0">
            <v-card>
                <v-toolbar dark flat :color="colorpick">
                    <v-toolbar-title>
                        <v-tooltip top eager close-delay=500 >
                            <template  v-slot:activator="{ on }">
                                <body slot="activator" v-on="on" @click="showTheBox=!showTheBox" :style="$store.state.textFormatting.headers"> {{top10Message}} </body>
                            </template>
                            <span :style="$store.state.textFormatting.main">
                                Will load the alerts that have happened to the user's selected ASNs <br /> 
                                The most recent day's events will always appear first <br /> 
                                Then the following most recent alerted day, then the rest of the days <br />
                                <b>Capped at 2000 alerts </b>
                            </span>
                        </v-tooltip>
                    </v-toolbar-title>
                    <v-toolbar-title>
                        <v-tooltip top color="secondary">
                            <template v-slot:activator="{ on }">
                                <small v-on="on" :style="$store.state.textFormatting.main"> (select row to see details) </small>         
                            </template>
                            <span :style="$store.state.textFormatting.main">(select row to see details)</span>
                        </v-tooltip>
                    </v-toolbar-title>

                    <v-progress-circular v-if="loading" indeterminate color="white" > </v-progress-circular>

                    <v-spacer></v-spacer>

                    <v-tooltip top eager close-delay=2000>
                        <template v-slot:activator="{ on }">
                            <v-flex v-on="on" shrink class="px-1 py-1">
                                <v-btn @click="flipPoll" :color="poll_color" :style="$store.state.textFormatting.main">{{poll_msg}} ({{ countDown }}s)</v-btn>
                            </v-flex>
                        </template>
                        <span v-if="!autoMerge" :style="$store.state.textFormatting.main"> Auto-merge <b>not</b> enabled. </span>
                        <span v-if="autoMerge" :style="$store.state.textFormatting.main"> Auto-merge enabled, go to 
                            <v-btn small @click="routeNewWindow('User Admin')" color="success" :style="$store.state.textFormatting.main">USER SETTINGS</v-btn>
                            disable it.    
                        </span>
                    </v-tooltip>
                    


                    <v-flex shrink class="px-1">
                        <v-tooltip top eager close-delay=500 >
                            <template v-slot:activator="{ on }">
                                <v-toolbar-title v-on="on">
                                    <small>
                                        <small :style="$store.state.textFormatting.main">
                                            {{ updatedStr }} 
                                        </small>
                                    </small>
                                </v-toolbar-title>
                            </template>
                            <span :style="$store.state.textFormatting.main"> {{ updatedStr }} </span>
                        </v-tooltip>
                    </v-flex>
                    
                    <info>
                        <template slot>
                            <h3> View recent episodes </h3>
                        </template>
                        <template slot="body">
                            <p> Shows <b> organisation </b> alerts (from organisation defined <b> ASNs </b> and <b> restricted prefixes</b>).
                                These, by default, are ordered by hijack score.
                            </p>
                            <br>
                            <p> Click the column headers to order the results. </p>
                            <p> Enable live alerting with the <v-btn color="success" :style="$store.state.textFormatting.main">Start live updates</v-btn> button. </p>
                            <p> Scored episodes and alerts are retained for <b> 30 days </b> before deletion </p>
                            <br>
                            <p> <b>Capped at 2000 alerts </b> </p>
                            <v-divider />
                            <p> Check the <b>reviewed</b> box and submit the alerts to mark them as reviewed. They will not appear in your alerts in the future. </p>
                            <p> Press the <b>'Show Reviewed Alerts'</b> button to show such alerts again. Check the <b>reviewed</b> box and submit the alerts to <b>insert them back into your live alert flow</b>. </p>
                            
                        </template>
                    </info>
                </v-toolbar>
                <v-card align-center justify-center>
                    <v-flex class="px-4 py-2">
                        <v-layout justify="center" align="center" fluid v-if="showTheBox">
                            <v-flex xs4>
                                <v-tooltip top eager close-delay=500 >
                                    <template  v-slot:activator="{ on }">
                                        <v-switch slot="activator" v-on="on" v-model="exclude_path_change" @change="excludeChange()">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include path change alerts </div>
                                            </template> 
                                        </v-switch>
                                    </template>
                                <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASNs are the same, i.e. no change of ownership</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs4>
                                <v-tooltip top eager close-delay=500 >
                                    <template  v-slot:activator="{ on }">
                                        <v-switch slot="activator" v-on="on" v-model="exclude_first_seen" @change="excludeChange()">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include first seen prefix alerts</div>
                                            </template>
                                        </v-switch>
                                    </template>
                                <span :style="$store.state.textFormatting.main">Alerts where there was no known path to the given prefix, prior to the event occuring (Old ASN = 0)</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs4 v-if="showUserTen">
                                <v-tooltip top eager close-delay=500 >
                                    <template  v-slot:activator="{ on }">
                                        <v-switch slot="activator" v-on="on" v-model="exclude_in_path" @change="excludeChange()">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include ASN in path alerts</div>
                                            </template>
                                        </v-switch>
                                    </template>
                                <span :style="$store.state.textFormatting.main">Alerts where the ASN of interest is in the AS path (i.e. not the origin ASN old or new). <br />
                                        Also filters out <b>restricted prefix</b> alerts.</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs4>
                                <v-tooltip top eager close-delay=500 >
                                    <template  v-slot:activator="{ on }">
                                        <v-switch slot="activator" v-on="on" v-model="exclude_own_assert" @change="excludeChange()">
                                            <template v-slot:label>
                                                <div :style="$store.state.textFormatting.main">Include ownership assertions</div>
                                            </template>
                                        </v-switch>
                                    </template>
                                <span :style="$store.state.textFormatting.main">Alerts where the old and new origin ASN are different i.e. an assertion of ownership over the prefix has occurred</span>
                                </v-tooltip>
                            </v-flex>
                        

                            <v-flex class="py-2 px-1" v-if="allow_dealt" xs4 align-center justify-center>
                                <v-tooltip top eager close-delay=500 >
                                    <template  v-slot:activator="{ on }">
                                        <v-btn @click="updateDealtWithMany(1)" color="success" v-on="on" :style="$store.state.textFormatting.main"> Update reviewed </v-btn>        
                                    </template>
                                <span :style="$store.state.textFormatting.main">Click here to remove the ticked alerts from your organisation's alerts</span>
                                </v-tooltip>
                                
                            </v-flex>

                        </v-layout>
                    </v-flex>
                    <v-layout column justify-space-around v-if="showTheBox">
                        <v-flex>
                            <v-progress-circular v-if="load_filtered" indeterminate secondary />
                            <v-data-table
                                :headers="headers"
                                :items="filtered_alerts"
                                :key="id"
                                :rows-per-page-items="rowsPerPageItems"
                                :pagination.sync="pagination"
                                v-if="!load_filtered&&table_buffer"
                            >
                                <template slot="headerCell" slot-scope="props">
                                    <v-tooltip top eager>
                                    <span slot="activator" :style="$store.state.textFormatting.main">
                                        <div v-for="line in props.header.text" :key="line.index">
                                            <div> {{ line }} </div>
                                        </div>
                                    </span>
                                    <span :style="$store.state.textFormatting.main">
                                        {{ props.header.ad_text }}
                                    </span>
                                    </v-tooltip>
                                </template>
                                <template slot="items" slot-scope="props">
                                <tr>
                                    <td class="text-xs-center" :style="$store.state.textFormatting.main" v-if="showUserTen"> 
                                        <v-checkbox class="text-xs-center" hide-details v-if="!props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 1)" />
                                        <v-checkbox class="text-xs-center" hide-details v-if="props.item.dealt_with_t" v-model="props.item.dealt_with_t" @change="tagDealtWith(props.item, 0)" />
                                    </td>
                                    
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main" v-if="showUserTen"> {{ props.item.alert_type }}</td>
                                    
                                    <td @click="clickHandleAlert(props.item)" class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.prefix }}</td>

                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.non_direct_prefix }}</td>

                                    <td @click="clickHandleAlert(props.item)"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_old]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_old }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_old] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_old]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_old }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>

                                    <td @click="clickHandleAlert(props.item)"  v-if="is_asn_owners" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.origin_asn_new]">
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.origin_asn_new }}</div>
                                            </template>
                                            <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.origin_asn_new] }}</span>
                                        </v-tooltip>
                                        <div v-if="!asn_own_dict[props.item.origin_asn_new]" :style="$store.state.textFormatting.main"> {{ props.item.origin_asn_new }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                    </td>

                                    <td @click="clickHandleAlert(props.item)" v-if="is_asn_owners&&showUserTen&&!props.item.bonus_interest" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <div v-if="props.item.controlled_prefix=='null'">
                                            <v-tooltip top eager color="primary" v-if="asn_own_dict[props.item.asn_of_interest]">
                                                <template v-slot:activator="{ on }">
                                                    <div v-on="on" :style="$store.state.textFormatting.main">{{ props.item.asn_of_interest }}</div>
                                                </template>
                                                <span :style="$store.state.textFormatting.main"> {{ asn_own_dict[props.item.asn_of_interest] }}</span>
                                            </v-tooltip>
                                            <div v-if="!asn_own_dict[props.item.asn_of_interest]" :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }} <v-progress-circular size="12" indeterminate color="purple" /></div>
                                        </div>
                                        <div v-if="props.item.controlled_prefix!='null'">
                                            <div :style="$store.state.textFormatting.main"> {{ props.item.asn_of_interest }} </div>
                                        </div>
                                    </td>

                                    <td v-if="is_asn_owners&&showUserTen&&props.item.bonus_interest" class="text-xs-center special" :style="$store.state.textFormatting.main">
                                        <div>
                                            <div :style="$store.state.textFormatting.main">
                                                {{ props.item.asn_of_interest }} 
                                                <v-icon small color="success" :style="$store.state.textFormatting.main" v-if="!props.item.bonus_show" @click="viewBonus(props.item)"> add </v-icon> 
                                            
                                                <v-icon small color="success" :style="$store.state.textFormatting.main" v-if="props.item.bonus_show" @click="viewBonus(props.item)"> remove </v-icon> 
                                                
                                                <small v-if="props.item.bonus_show">
                                                    <br />
                                                    AS: {{ props.item.bonus_interest }}
                                                </small>
                                            </div>
                                        </div>
                                    </td>

                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.hijack_score_mean }}</td>

                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.impact_score_mean }}</td>

                                    <!-- <td class="text-xs-center special"> {{ props.item.event_count }}</td> !-->
                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> <v-chip class="special" :color="getColor(props.item.interval_start.date)" text-color="#000000" dark :style="$store.state.textFormatting.main">{{ props.item.interval_start.date }}</v-chip> </td>

                                    <!-- <td class="text-xs-center special"> {{ props.item.interval_start.date }}</td> -->
                                    <td @click="clickHandleAlert(props.item)"  class="text-xs-center special" :style="$store.state.textFormatting.main"> {{ props.item.interval_start.time }}</td>
                                </tr>
                                </template>
                                <template slot="no-data">
                                <v-alert
                                    :value="true"
                                    color="success"
                                    icon="warning"
                                    :style="$store.state.textFormatting.main"
                                >No alerts - consider changing sliders above</v-alert>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center align-center v-if="showTheBox">
                        <v-flex xs4 class="px-2 py-2">
                            <v-btn color="success" v-if="allow_popped" @click="showPoppedAlerts()" :style="$store.state.textFormatting.main"> Show 'Reviewed' Alerts </v-btn>
                            <v-btn color="success" v-if="!allow_popped" @click="showUnpoppedAlerts()" :style="$store.state.textFormatting.main"> Show Live Alerts </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center align-center v-if="showTheBox">
                        <v-flex xs12 class="px-2 py-2">
                            <v-divider />
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center align-center v-if="showTheBox">
                        <v-flex xs1 />
                        <v-flex xs4  class="px-2 py-2">
                            <v-btn color="success" @click="getAllUserAlerts(allRound)" :style="$store.state.textFormatting.main">  <v-icon>save_alt</v-icon> {{ downloadStr }} </v-btn>
                        </v-flex>
                        <v-spacer />
                        <v-flex justify-center align-center class="px-2 py-2">
                            <v-icon v-if="allLoading" large> trending_flat </v-icon>
                            <v-progress-circular v-if="allLoading" indeterminate color="purple" />         
                            <v-icon v-if="allLoading" large> trending_flat </v-icon>

                            <h4 v-if="allErrMsg" :style="$store.state.textFormatting.main"> {{allErrMsg}} </h4>
                        </v-flex>
                        <v-flex xs4 class="px-2 py-2">
                            <downloadcsv
                            class   = "btn btn-default"
                            :data   = "allUserAlerts"
                            :name = "downloadName">
                                <v-tooltip top eager color="primary" id="exit-app">
                                    <template v-slot:activator="{ on }">
                                        <v-btn small dark v-on="on" color="success" :disabled="!showAllDownload" :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> CSV </v-btn>
                                    </template>
                                    <span :style="$store.state.textFormatting.main"> <v-icon>save_alt</v-icon> CSV of {{ oldDownStr }}</span>
                                </v-tooltip>
                                
                            </downloadcsv>
                        </v-flex>
                    </v-layout>
                </v-card>
            
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>

import { API, graphqlOperation } from 'aws-amplify';
import info from './infopopout.vue'
import { mdiArrowRight } from '@mdi/js';
import downloadcsv from 'vue-json-csv';
import bubbleGraph from '../developing/bubble-graph.js'

export default {
    name: 'top10liveupdate',
    components: {
        info,
        downloadcsv,
        bubbleGraph
    },
    data () {
        return {
            allRound: 0,
            downloadName: "organisationAlerts.csv",
            username: "",
            showTheBox: true,
            allUserAlerts: [],
            allLoading: false,
            allErrMsg: false,
            showAllDownload: false,
            downloadStr: "1000 most recent alerts",
            oldDownStr: "1000 most recent alerts",
            showUserTen: false,
            exclude_first_seen: false,
            exclude_path_change: false,
            exclude_in_path: false,
            exclude_own_assert: false,
            userSpecificOrderBy: null,
            prefix: null,
            orderby: "hijack_score_mean",
            top10Message: "Recent Episodes",
            showUserTopTen: false,
            selectedAlertRouting: "/alert",
            pagination: {
                rowsPerPage: 10,
                sortBy: null,
                descending: null
            },
            rowsPerPageItems: [10, 20, 30, 40, 50, 100],
            pagination2: {
                rowsPerPage: 10,
                sortBy: null,
                descending: null
            },
            rowsPerPageItems2: [10, 20, 30, 40, 50, 100],
            
            organisation: '',
            useHeaders: [
                { text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['ASDASD', 'Matched', 'ASN/ Prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            headers: [
                { text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['ASDASD', 'Matched', 'ASN/ Prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            headersGlobal: [
                //{ text: 'Reviewed', sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                //{ text: 'User ASN', value: 'asn_of_interest', align:'centre', ad_text: 'ASN designated by user which generated this alert'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            id: null,
            alertperasn: [],
            isdata: true,
            updatedStr: "",
            loading: false,
            expand: false,
            ddinfo: {},
            orderByList: [{name: "New ASN", param: "origin_asn_new"},
                        {name: "Old ASN", param: "origin_asn_old"},
                        {name: "Time", param: "time_5min"},
                        {name: "Hijack Score", param: "hijack_score_mean"},
                        {name: "Impact Score", param: "impact_score_mean"},
                        //{name: "Validation Score", param: "event_count"},
                        {name: "Prefix", param: "prefix"}
            ],
            orderMatch: { "origin_asn_new": "Origin ASN New",
                    "origin_asn_old": "Origin ASN Old",
                    "time_5min": "Time",
                    "hijack_score_mean": "Hijack Score",
                    "impact_score_mean": "Impact Score",
                    //"event_count": "Validation Score",
                    "prefix": "Prefix"
            },
            allowExcludeSwitches: false,
            colors: [
                'tertiary',
                'secondary',
                'accent'
            ],
            colorpick: 'secondary',
            textheader: {
                fontSize: '20px'
            },
            textstandard: {
                fontSize: '14px'
            },
            asn_own_dict: {},
            asn_get_owner: [],
            is_asn_owners: true,
            to_be_dealt: [],
            allow_dealt: false,
            show_popped: '',
            allow_popped: true,
            alert_keys: {},
            table_buffer: true,
            overarching_type: 'organisation',
            last_run_ts: null,
            user_alerts: [],
            user_recent_alerts: [],
            user_bonus_alerts: [],
            org_alerts: [],
            org_recent_alerts: [],
            org_bonus_alerts: [],
            polling: null,
            run_poll: false,
            polling_interval: 10,
            polling_interval_rules: [v => v >= 10 || "Min. 10s polling interval"],
            org_asns: {},
            org_asns_arr: [],
            org_prefixes: {},
            org_prefixes_arr: [],
            org_bonus_asns: {},
            org_bonus_asns_arr: [],
            org_bonus_prefixes: {},
            org_bonus_prefixes_arr: [],
            user_asns: {},
            user_asns_arr: [],
            user_prefixes: {},
            user_prefixes_arr: [],
            user_bonus_asns: {},
            user_bonus_asns_arr: [],
            user_bonus_prefixes: {},
            user_bonus_prefixes_arr: [],
            poll_color: "success",
            poll_msg: "Start Live Updates",
            hijack_danger_threshold: 50,
            user_summarised: null,
            org_summarised: null,
            user_summarised_str: null,
            org_summarised_str: null,
            checker_local: false,
            filtered_alerts: [],
            load_filtered: false,
            load_user: true,
            load_org: true,
            showalerts: false,
            filter_criteria: {
                user: "",
                prefix: "",
                asn: ""
            },
            newalertsbanner_org: true,
            newalerts_org: false,
            newalertsbanner_user: true,
            newalerts_user: false,
            alertsbannercolor_org: "blue",
            alertsbannercolor_user: "blue",
            newalertsmessage_org: "test",
            newalertsmessage_user: "test",
            adding_alerts: false,
            org_alerts_flip: true,
            user_alerts_flip: true,
            org_only: false,
            org_prefix_names: {},
            org_show_names: false,
            user_prefix_names: {},
            user_show_names: false,
            options: {
                animation: {
                    duration: 0 // general animation time
                },
                hover: {
                    animationDuration: 0 // duration of animations when hovering an item
                },
                responsiveAnimationDuration: 0, // animation duration after a resize
                onClick: this.chartHandle,
                passive: true,
                //aspectRatio: 0.2,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 50,
                        right: 50,
                        top: 50,
                        bottom: 50
                    }
                },
                legend: {
                    display: true,
                    labels: {
                        // This more specific font property overrides the global property
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                    }
                },
                tooltips: {
                    bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10,
                    callbacks: {
                        label: function(tooltipItem, data ) {
                            try {
                                var interest = data.datasets[tooltipItem.datasetIndex].label
                                /*if (!(interest.includes("/"))) {
                                    interest = "AS" + interest
                                }*/
                                var event = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].full_alert
                                var eventCount = event.event_count
                                if (eventCount ==50) {
                                    eventCount= "50+"
                                }
                                var comboScore = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
                                var epochTime = tooltipItem.xLabel
                                var d_t = new Date( epochTime *1000);
                                var date = d_t.toLocaleString().substr(0, 10);
                                var time = d_t.toLocaleString().substr(11, 9);
                                var label = "ASN/Prefix: " + interest + ", Hijack Score: " +comboScore+  ", Event Count: "+eventCount+", Date: " +date + ", Time: " + time

                                return label
                            } catch(err) {
                                console.log(err)
                            }
                        }
                    }
                },
                responsive: true,
                
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Hijack Score (H)',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            min: 0,
                            stepSize: 20,
                            max: 100,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontSize: this.$store.state.textFormatting.chart.axis_label,
                            callback: (value, index, values) => {
                                var dataPointEpochTimeInHRFormat = new Date (value *1000);
                                let dateTime = dataPointEpochTimeInHRFormat.toLocaleString().split(", ");
                                return dateTime[0].split("/")[0] + "/" + dateTime[0].split("/")[1] + " " + dateTime[1].split(":")[0] + ":" + dateTime[1].split(":")[1];  
                            }
                        }
                    }]
                },
                pan: {
                    enabled: true,
                    passive: true,
                    mode: 'x'
                },
                zoom: {
                    enabled: true,
                    passive: true,
                    mode: 'x',
                }
            },
            bubbleData: null,
            user_bubbledata: null,
            org_bubbledata: null,
            showbubble: false,
            bubble_type: null,
            countDown: 10,
            countDownSt: 10,
            countdownColor: 'success',
            allowCount: false,
            bubble_alert: false,
            bubbleHeaders: [
                //{ text: ['Reviewed'], sortable: false, value: 'dealt_with_t', align: 'centre', ad_text: 'Check the box and submit the alerts and they will not appear in your organisation alerts any longer'},
                { text: ['Alert Type'], value: 'alert_type', align:'centre', ad_text: 'The type of alert, see glossary for details'},
                { text: ['Advertised', 'Prefix'], value:'prefix', align:'centre', ad_text: 'Prefix of the alert'},
                { text: ['Sub/Super', 'Ownership', 'Prefix'], value:'non_direct_prefix', align:'centre', ad_text: 'Where a sub/super ownership assertion occurs, this will display the parent/child prefix of the alert'},
                { text: ['Old', 'ASN'], value:'origin_asn_old', align:'centre', ad_text: 'Former ASN, having ownership asserted upon'},
                { text: ['New', 'ASN'], value:'origin_asn_new', align:'centre', ad_text: 'New ASN asserting ownership'},
                { text: ['ASDASD', 'Matched', 'ASN/ prefix'], value: 'asn_of_interest', align:'centre', ad_text: 'ASN or restricted prefix designated by user which generated this alert'},
                { text: ['Hijack', 'Score'], value: 'hijack_score_mean', align:'centre', ad_text: 'Hijack score of alert'},
                { text: ['Impact', 'Score'], value: 'impact_score_mean', align:'centre', ad_text: 'Impact score of alert'},
                { text: ['Date'], value:'time_5min', align:'centre', ad_text: 'Date'},
                { text: ['Time'], value:'time_5min', align:'centre', ad_text: 'Time of alert'}
            ],
            bubbleMaxSize: 20,
            bubbleMinSize: 3,
            distinct_colors: [
                '#e6194b', 
                '#3cb44b', 
                '#ffe119', 
                '#4363d8', 
                '#f58231', 
                '#911eb4', 
                '#46f0f0', 
                '#f032e6', 
                '#bcf60c', 
                '#fabebe', 
                '#008080', 
                '#e6beff', 
                '#9a6324', 
                '#fffac8', 
                '#800000', 
                '#aaffc3', 
                '#808000', 
                '#ffd8b1', 
                '#000075', 
                '#808080', 
                //'#ffffff', remove white
                '#000000'
            ],
            reviewed_alerts: [],
            new_updated: false,
            autoMerge: false,
            reviewed_asns: [],
            reviewed_prefixes: [],
            reviewed_bubbledata: false
        }
    },
    beforeMount () {
        if (this.$attrs.overarching_type) {
            this.overarching_type = this.$attrs.overarching_type;
        }
        if (this.$store.state.showSettings.autoMerge) {
            this.autoMerge = true
        }
        this.showbubble = this.$store.state.showSettings.showBubble
    },
    mounted () {
        try {
            this.organisation = this.$store.state.user.organisation;
            this.username = this.$store.state.user.username;
            if (this.overarching_type == 'organisation') {
                this.headers[6].text[0] = this.organisation;
                this.downloadName="organisationAlerts.csv"
            } else {
                this.headers[6].text[0] = this.username;
                this.downloadName="userAlerts.csv"
            }

        } catch (err) {
            console.log(err)
            location.reload()
        }
        this.exclude_path_change = this.$store.state.alertsExcPath
        this.exclude_first_seen = this.$store.state.alertsExcFirst
        this.exclude_in_path = this.$store.state.alertsExcInPath
        this.exclude_own_assert = this.$store.state.alertsExcOwnAssert

        //this.top10alertsUser();
        this.showUserTen = true
        this.allowExcludeSwitches = true;
        this.run_poll = false;
        this.allowCount = true;
        this.countdownTimer();
    },
    beforeDestroy () {
        this.allowCount = false;
    },
    methods: {
        routeNewWindow: async function (input) {
            let routeData = this.$router.resolve({name: input});
            window.open(routeData.href, '_blank');
        },
        chartHandle: async function (point, event) {
            //console.log(point)
            //console.log(event)
            if ( event.length > 0 ) {
                //console.log(event[0]._datasetIndex)
                //console.log(event[0]._index)
                //console.log(this.bubbleData.datasets[event[0]._datasetIndex].data[event[0]._index])
                this.bubble_alert = [this.bubbleData.datasets[event[0]._datasetIndex].data[event[0]._index].full_alert]
            }
        },
        countdownTimer: function () {
            if ( this.countDown > 0 && this.run_poll ) {
                setTimeout(() => {
                this.countDown -= 1
                this.preCountdownTimer()
                }, 1000)
            } else if ( this.run_poll ) {
                console.log("RUNNING ALERTS FROM COUNTDOWN")
                this.pullNewAlerts()
                this.countDown = this.countDownSt
                this.preCountdownTimer();
            } else {
                setTimeout(() => {
                this.preCountdownTimer()
                }, 1000)
            }
        },
        preCountdownTimer: function () {
            if (this.allowCount) {
                this.countdownTimer()
            }
        },
        bubbleExclude: async function () {
            this.user_bubbledata = this.createBubbleDatasets('user')
            this.org_bubbledata = this.createBubbleDatasets('organisation')
            this.reviewed_bubbledata = this.createBubbleDatasets('dealt_with')
            if (this.bubble_type == 'organisation') {
                this.useBubbleData('organisation')
            } else {
                this.useBubbleData('user')
            }
        },
        useBubbleData: async function (usr) {
            if (usr == 'user') {
                var stored = this.showbubble
                this.showbubble = false
                //this.bubble_alert = false
                this.bubble_type = 'user'
                if (this.allow_popped) {
                    this.bubbleData = this.user_bubbledata
                } else {
                    this.bubbleData = this.reviewed_bubbledata
                }
                this.bubbleHeaders[5].text[0] = this.username
                this.showbubble = stored
            } else {
                var stored = this.showbubble
                this.showbubble = false
                //this.bubble_alert = false
                this.bubble_type = 'organisation'
                if (this.allow_popped) {
                    this.bubbleData = this.org_bubbledata
                } else {
                    this.bubbleData = this.reviewed_bubbledata
                }
                this.bubbleHeaders[5].text[0] = this.organisation
                this.showbubble = stored
            }
        },
        createBubbleDatasets: function(usr) {

            var uniqueASNs
            var uniquePrefs
            var alerts
            var current_keys
            var used_colours = [];

            if (usr == 'user') {
                uniqueASNs = Object.keys(this.user_asns)
                uniquePrefs = Object.keys(this.user_prefixes)
                alerts = this.user_alerts
                current_keys = {}
                try {
                    for (var i = 0 ; i < this.user_bubbledata.datasets.length ; i++ ) {
                    current_keys[this.user_bubbledata.datasets[i].label] = this.user_bubbledata.datasets[i].backgroundColor
                    used_colours.push(this.user_bubbledata.datasets[i].backgroundColor)
                    }
                } catch {
                    current_keys = {}
                }
                
            } else if (usr == 'dealt_with') {
                uniqueASNs = Object.keys(this.reviewed_asns)
                uniquePrefs = Object.keys(this.reviewed_prefixes)
                alerts = this.reviewed_alerts
                current_keys = {}
                try {
                    for (var i = 0 ; i < this.reviewed_bubbledata.datasets.length ; i++ ) {
                    current_keys[this.reviewed_bubbledata.datasets[i].label] = this.reviewed_bubbledata.datasets[i].backgroundColor
                    used_colours.push(this.reviewed_bubbledata.datasets[i].backgroundColor)
                    }
                } catch {
                    current_keys = {}
                }
                
            } else {
                uniqueASNs = Object.keys(this.org_asns)
                uniquePrefs = Object.keys(this.org_prefixes)
                alerts = this.org_alerts
                current_keys = {}
                try {
                    for (var i = 0 ; i < this.org_bubbledata.datasets.length ; i++ ) {
                    current_keys[this.org_bubbledata.datasets[i].label] = this.org_bubbledata.datasets[i].backgroundColor
                    used_colours.push(this.user_bubbledata.datasets[i].backgroundColor)
                    }
                } catch {
                    current_keys = {}
                }
            }

            //console.log(uniqueASNs)
            //console.log(uniquePrefs)
            //console.log(alerts)
            //console.log(current_keys)
            let available_colours = this.distinct_colors.filter(x => !used_colours.includes(x));
            var total_colours = available_colours.length;
            var colour_count = 0
            var bubbleData = {
                datasets: []
            }

            for (var i = 0; i < uniqueASNs.length; i++ ) {
                if (!(Object.keys(current_keys).includes(uniqueASNs[i]))) {
                    if ( colour_count < total_colours ) {
                        var datasetFull = {
                            label: uniqueASNs[i],
                            data: [],
                            backgroundColor: available_colours[colour_count]
                        }
                        colour_count += 1
                    } else {
                        var datasetFull = {
                            label: uniqueASNs[i],
                            data: [],
                            backgroundColor: "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
                        }
                    }
                    bubbleData.datasets.push(datasetFull)
                } else {
                    var datasetFull = {
                        label: uniqueASNs[i],
                        data: [],
                        backgroundColor: current_keys[uniqueASNs[i]]
                    }
                    bubbleData.datasets.push(datasetFull)
                }
            }

            for (var i = 0; i < uniquePrefs.length; i++ ) {
                if (!(Object.keys(current_keys).includes(uniquePrefs[i]))) {
                    if ( colour_count < total_colours ) {
                        var datasetFull = {
                            label: uniquePrefs[i],
                            data: [],
                            backgroundColor: available_colours[colour_count]
                        }
                        colour_count += 1
                    } else {
                        var datasetFull = {
                            label: uniquePrefs[i],
                            data: [],
                            backgroundColor: "hsla(" + ~~(360 * Math.random()) + "," +"50%,"+"50%,1)"
                        }
                    }
                    bubbleData.datasets.push(datasetFull)
                } else {
                    var datasetFull = {
                        label: uniquePrefs[i],
                        data: [],
                        backgroundColor: current_keys[uniquePrefs[i]]
                    }
                    bubbleData.datasets.push(datasetFull)
                }
            }

            

            //console.log(bubbleData)

            for (var i=0 ; i < alerts.length; i++ ) {
                
                if (this.passCriteria(alerts[i])) {


                if (alerts[i].asn_of_interest == 'Restricted Prefix') {
                    //console.log(alerts[i].controlled_prefix)
                    var score_combo = alerts[i].hijack_score_mean
                    if ( alerts[i].event_count > 50 ) {
                        var bubblesize = this.bubbleMaxSize
                    } else {
                        var bubblesize = Math.round(alerts[i].event_count * (this.bubbleMaxSize - this.bubbleMinSize)/50) + this.bubbleMinSize
                    }
                    var dataset = {x: alerts[i].time_5min, y: score_combo, r: bubblesize, ev_count: alerts[i].event_count, full_alert: alerts[i]}
                    for(var j = 0; j < bubbleData.datasets.length ; j++ ) {
                    if (bubbleData.datasets[j].label == alerts[i].controlled_prefix) {
                        bubbleData.datasets[j].data.push(dataset)
                    }  
                    }

                } else {
                    //console.log(alerts[i].asn_of_interest)
                    var score_combo = alerts[i].hijack_score_mean
                    if ( alerts[i].event_count > 50 ) {
                        var bubblesize = this.bubbleMaxSize
                    } else {
                        var bubblesize = Math.round(alerts[i].event_count * (this.bubbleMaxSize - this.bubbleMinSize)/50) + this.bubbleMinSize
                    }
                    var dataset = {x: alerts[i].time_5min, y: score_combo, r: bubblesize, ev_count: alerts[i].event_count, full_alert: alerts[i]}
                    for(var j = 0; j < bubbleData.datasets.length ; j++ ) {
                    if (bubbleData.datasets[j].label == alerts[i].asn_of_interest) {
                        bubbleData.datasets[j].data.push(dataset)
                    }  
                    }
                    
                }
                }            
                
            }

            var legend_length = 0
            try {
                for (var j = 0 ; j < bubbleData.datasets.length ; j ++ ) {
                    if (bubbleData.datasets[j].label.includes('/')) {
                        legend_length += 2
                    } else {
                        legend_length += 1
                    }
                }
                console.log(legend_length)
                if (legend_length > 21 ) {
                    this.options.legend.display = false
                }
            } catch {
                this.options.legend.display = true
            }


            return bubbleData
        },
        mergeAlerts: async function(usr) {
            if (!this.adding_alerts) {
                var alerts;
                var newalerts;
                var is_new;
                this.adding_alerts = true;
                if (usr == "user") {
                    newalerts = this.user_bonus_alerts;
                    alerts = this.user_alerts;
                } else {
                    newalerts = this.org_bonus_alerts;
                    alerts = this.org_alerts;
                }
                //const pr_alerts = Array.from(newalerts)
                //console.log(pr_alerts)
                for (var i = 0; i < alerts.length; i++) {
                    //console.log(i);
                    if (i > 0) {
                        break
                    }
                    if (newalerts != [] && newalerts[i]) {
                        //console.log(newalerts[i].prefix);
                        // de-duplication
                        is_new = true;
                        if (!(Object.keys(this.alert_keys).includes(newalerts[i].prefix))) {
                            this.alert_keys[newalerts[i].prefix] = {}
                        }
                        if (!(Object.keys(this.alert_keys[newalerts[i].prefix]).includes(newalerts[i].time_5min))) {
                            this.alert_keys[newalerts[i].prefix][newalerts[i].time_5min] = []
                        }
                        if (this.alert_keys[newalerts[i].prefix][newalerts[i].time_5min].includes((newalerts[i].origin_asn_old + "," + newalerts[i].origin_asn_new).toString())) {
                            is_new = false
                            //console.log("OLD ALERT")
                            //console.log(newalerts[i])
                            for (var j = 0 ; j < alerts.length ; j++ ) {
                                var currentAlert = alerts[j]
                                if (
                                    currentAlert.prefix == newalerts[i].prefix && 
                                    currentAlert.origin_asn_new == newalerts[i].origin_asn_new && 
                                    currentAlert.origin_asn_old == newalerts[i].origin_asn_old && 
                                    currentAlert.time_5min == newalerts[i].time_5min
                                ) {
                                    currentAlert.impact_score_mean = Math.max(currentAlert.impact_score_mean, newalerts[i].impact_score_mean)
                                    if (!(currentAlert.asn_of_interest.includes('/'))) {
                                        currentAlert.bonus_interest = currentAlert.asn_of_interest
                                        currentAlert.asn_of_interest = newalerts[i].asn_of_interest
                                        currentAlert.bonus_show = false
                                        console.log(currentAlert)
                                    } else {
                                        currentAlert.bonus_interest = newalerts[i].asn_of_interest
                                        currentAlert.bonus_show = false
                                        console.log(currentAlert)
                                    }
                                }
                            }
                        } else {
                            this.alert_keys[newalerts[i].prefix][newalerts[i].time_5min].push(
                                (newalerts[i].origin_asn_old + "," + newalerts[i].origin_asn_new).toString()
                            )
                        }
                        if (is_new) {
                            alerts.push(newalerts[i]);
                        }
                        newalerts.splice(i, 1)
                        i -= 1;
                    }
                }
                //console.log(newalerts)
                if (newalerts.length == 0) {
                    if (usr == 'user') {
                        console.log("REDOING AGGREGATION (user)")
                        this.user_bubbledata = this.createBubbleDatasets('user')
                        this.useBubbleData('user')
                        this.user_bonus_alerts = []
                        this.user_bonus_prefixes = {}
                        this.user_bonus_prefixes_arr = []
                        this.user_bonus_asns = {}
                        this.user_bonus_asns_arr = []
                    } else {
                        console.log("REDOING AGGREGATION (org)")
                        this.org_bubbledata = this.createBubbleDatasets('organisation')
                        this.useBubbleData('organisation')
                        this.org_bonus_alerts = []
                        this.org_bonus_prefixes = {}
                        this.org_bonus_prefixes_arr = []
                        this.org_bonus_asns = {}
                        this.org_bonus_asns_arr = []
                    }
                }
                this.adding_alerts = false
                this.excludeChange();
            } else {
                console.log("currently adding alerts already");
            }
        },
        passCriteria: function(alert) {
            if (!this.exclude_first_seen && alert.origin_asn_old == "0") {
                return false;
            }
            if (
                !this.exclude_path_change &&
                alert.origin_asn_old == alert.origin_asn_new
            ) {
                return false;
            }
            if (
                !this.exclude_own_assert &&
                alert.origin_asn_old != alert.origin_asn_new &&
                alert.origin_asn_old != "0"
            ) {
                return false;
            }
            if (
                (
                !this.exclude_in_path &&
                alert.origin_asn_old != alert.asn_of_interest &&
                alert.origin_asn_new != alert.asn_of_interest
                ) && (
                alert.asn_of_interest != 'Restricted Prefix'
                )
            ) {
                return false;
            }
            return true;
        },
        filterAlerts: async function(user, cont_prefix, asn) {
            var alerts;
            this.load_filtered = true;
            this.to_be_dealt = []
            this.allow_dealt = false

            console.log("filtering: prefix = " + cont_prefix + ", asn: " + asn);
            this.filtered_alerts = [];
            if (user == "user") {
                this.headers[6].text[0] = this.username
                alerts = this.user_alerts;
            } else if (user == "newuser") {
                this.headers[6].text[0] = this.username
                alerts = this.user_bonus_alerts;
            } else if (user == "neworg") {
                this.headers[6].text[0] = this.organisation
                alerts = this.org_bonus_alerts;
            } else if (user == "reviewed") {
                if (this.overarching_type == 'user') {
                    this.headers[6].text[0] = this.username
                } else {
                    this.headers[6].text[0] = this.organisation
                }
                alerts = this.reviewed_alerts;
            } else {
                this.headers[6].text[0] = this.organisation
                alerts = this.org_alerts;
            }

            for (var i = 0; i < alerts.length; i++) {
                if (cont_prefix == "" && asn == "") {
                if (this.passCriteria(alerts[i])) {
                    this.filtered_alerts.push(alerts[i]);
                }
                } else {
                if (cont_prefix == "") {
                    //searching in ASN summary
                    if (
                    alerts[i].asn_of_interest == asn &&
                    this.passCriteria(alerts[i])
                    ) {
                    this.filtered_alerts.push(alerts[i]);
                    }
                } else {
                    if (
                    alerts[i].asn_of_interest == cont_prefix &&
                    alerts[i].controlled_prefix == cont_prefix &&
                    this.passCriteria(alerts[i])
                    ) {
                    this.filtered_alerts.push(alerts[i]);
                    }
                }
                }
            }
            this.load_filtered = false;
            this.filter_criteria = {
                user: user,
                prefix: cont_prefix,
                asn: asn
            };
            this.showalerts = true;
            if (user == 'user') {
                this.user_bubbledata = this.createBubbleDatasets('user')
                this.useBubbleData('user')
            } else if (user == 'reviewed') {
                this.reviewed_bubbledata = this.createBubbleDatasets('dealt_with')
                this.useBubbleData('dealt_with')
            } else {
                this.org_bubbledata = this.createBubbleDatasets('organisation')
                this.useBubbleData('organisation')
            }
        },
        flipPoll: async function() {
            if (this.run_poll) {
                this.run_poll = false;
                this.poll_msg = "Start Live Updates";
                this.poll_color = "success";

            } else {
                this.run_poll = true;
                this.poll_msg = "Stop Live Updates";
                this.poll_color = "red";
            }
        },
        pullNewAlerts: async function() {
            if (this.run_poll) {
                console.log("running poll for new alerts...");
                this.pullNewAlertsDo();
                var d = new Date();
                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) ;
                this.updatedStr = "Last update: " + dateFormatted + " " + timeFormatted
            } else {
                console.log("not running poll (set not to run)");
            }
        },
        pullNewAlertsDo: async function() {
            if (this.overarching_type == 'user') {
                console.log('USER TYPE')
                var orgalerts = this.user_recent_alerts;
                var latest_alert_ts = this.user_last_run_ts + 300;
            } else {
                console.log('ORGANISATION TYPE')
                var orgalerts = this.org_recent_alerts;
                var latest_alert_ts = this.org_last_run_ts + 300;
            }
            console.log(orgalerts)
            console.log(latest_alert_ts)
            var neworgalerts = await this.liveQueryPull(this.overarching_type);
            
            for (var i = 0; i < neworgalerts.length; i++) {
                var newalert = neworgalerts[i];
                var n = 1; //is it new or not
                if (newalert.time_5min > latest_alert_ts) {
                latest_alert_ts = newalert.time_5min;
                }

                if (newalert.asn_of_interest == "99999999999") {
                newalert.asn_of_interest = "Restricted Prefix";
                }
                if (newalert.non_direct_prefix == "null") {
                newalert.non_direct_prefix = "N/A";
                }

                newalert.alert_type = this.getAlertType(newalert)

                newalert.dealt_with_t = false;

                if (!this.asn_get_owner.includes(newalert.asn_of_interest.toString())) {
                this.asn_get_owner.push(newalert.asn_of_interest);
                }

                if (!this.asn_get_owner.includes(newalert.origin_asn_old.toString())) {
                this.asn_get_owner.push(newalert.origin_asn_old);
                }
                if (!this.asn_get_owner.includes(newalert.origin_asn_new.toString())) {
                this.asn_get_owner.push(newalert.origin_asn_new);
                }

                newalert.asn_of_interest = newalert.asn_of_interest.toString();

                var epochTime = newalert.interval_start;
                var dateTime = this.convertEpochtoTimeDate(epochTime);
                newalert.time_5min = epochTime;
                newalert.interval_start = dateTime;

                // we set the asn of interest to the restricted prefix for display purposes
                if (newalert.controlled_prefix != 'null' && newalert.asn_of_interest == 'Restricted Prefix') {
                    newalert.asn_of_interest = newalert.controlled_prefix
                }

                for (var j = 0; j < orgalerts.length; j++) {
                    var alert = orgalerts[j];

                    if (
                        alert["prefix"] == newalert["prefix"] &&
                        alert["origin_asn_new"] == newalert["origin_asn_new"] &&
                        alert["origin_asn_old"] == newalert["origin_asn_old"] &&
                        alert["time_5min"] == newalert["time_5min"] &&
                        alert["asn_of_interest"] == newalert["asn_of_interest"] &&
                        alert["controlled_prefix"] == newalert["controlled_prefix"]
                    ) {
                        n = 0;
                    }
                    if (j == orgalerts.length - 1 && n == 1) {
                        if (this.overarching_type == 'user') {
                            this.user_bonus_alerts.push(newalert);
                            this.user_recent_alerts.push({
                            prefix: newalert.prefix,
                            origin_asn_new: newalert.origin_asn_new,
                            origin_asn_old: newalert.origin_asn_old,
                            time_5min: newalert.time_5min,
                            asn_of_interest: newalert.asn_of_interest,
                            controlled_prefix: newalert.controlled_prefix
                            });
                        } else {
                            this.org_bonus_alerts.push(newalert);
                            this.org_recent_alerts.push({
                            prefix: newalert.prefix,
                            origin_asn_new: newalert.origin_asn_new,
                            origin_asn_old: newalert.origin_asn_old,
                            time_5min: newalert.time_5min,
                            asn_of_interest: newalert.asn_of_interest,
                            controlled_prefix: newalert.controlled_prefix
                            });
                        }
                    }
                }
                if (i == neworgalerts.length - 1) {
                    if (this.overarching_type == 'user') {
                        this.user_last_run_ts = latest_alert_ts - 300;
                    } else {
                        this.org_last_run_ts = latest_alert_ts - 300;
                    }
                    if (this.autoMerge) {
                        console.log("AUTO MERGING")
                        this.mergeAlerts(this.overarching_type)
                    }
                }
            }
            return 1;
        },
        liveQueryPull: async function(u) {
            if (u == "user") {
                var usr = this.username;
                var ts = this.user_last_run_ts;
            } else {
                var usr = "whole_organisation";
                var ts = this.org_last_run_ts;
            }

            if(ts < 0) {
                ts = 0
            }

            try {
                var query =
                `query getLiveNotificationsForOrg { getLiveNotificationsForOrg (
                                p_organisation: "` +
                this.organisation +
                `", 
                                p_user: "` +
                usr +
                `",
                                st_time: ` +
                ts +
                `
                            ) {
                                prefix
                                origin_asn_new
                                origin_asn_old
                                interval_start
                                hijack_score_min
                                impact_score_min
                                hijack_score_max
                                impact_score_max
                                hijack_score_mean
                                impact_score_mean
                                asn_of_interest
                                validation
                                event_count
                                countdown
                                email_count
                                organisation_name
                                notified_organisation
                                asn_class
                                dealt_with
                                user
                                controlled_prefix
                                non_direct_prefix
                            }  
                        }`;
                console.log(query);
                const liveData = await API.graphql(graphqlOperation(query));
                console.log(liveData);
                var liveResults = liveData.data.getLiveNotificationsForOrg;
                console.log(liveResults);
                return liveResults;
            } catch (err) {
                console.log(err);
                return [];
            }
        },

        top10alerts: async function(u) {
            
            var order = "hijack_score_mean";
            var is_new;
            var use_alerts;
            this.loading = true;
            if (this.allow_popped) {
                this.user_recent_alerts = [];
                this.org_recent_alerts = [];
                this.to_be_dealt = [];
                this.allow_dealt = false;
                
                if (u == "user") {
                    var usr = this.username;
                    use_alerts = this.user_alerts;
                } else {
                    var usr = "whole_organisation";
                    use_alerts = this.org_alerts;
                }
            } else {
                this.reviewed_alerts = [];
                use_alerts = this.reviewed_alerts;
                if (u == "user") {
                    var usr = this.username;
                } else {
                    var usr = "whole_organisation";
                    
                }
            }
            try {
                var query =
                `query top10 { getNotificationsForOrg (
                                page_offset: 0, 
                                page_rows: 2000, 
                                order_by:"` +
                order +
                `",
                                exclude_path_change: false,
                                exclude_first_seen: false,
                                exclude_in_path: false,
                                p_user: "` +
                usr +
                `" 
                                exclude_own_assert: false ` +
                this.show_popped +
                `
                            ) {
                                prefix
                                origin_asn_new
                                origin_asn_old
                                interval_start
                                hijack_score_min
                                impact_score_min
                                hijack_score_max
                                impact_score_max
                                hijack_score_mean
                                impact_score_mean
                                asn_of_interest
                                validation
                                event_count
                                countdown
                                email_count
                                controlled_prefix
                                organisation_name
                                notified_organisation
                                asn_class
                                dealt_with
                                user
                                non_direct_prefix
                            }  
                        }`;
                console.log(query);
                const top10data = await API.graphql(graphqlOperation(query));
                console.log(top10data);
                var t10 = top10data.data.getNotificationsForOrg;
                console.log(t10);
                var latest_alert_ts = 0;
                const time_delay = 600; //10 mins

                if (this.allow_popped) {
                    for (var n = 0; n < t10.length; n = n + 1) {
                        if (t10[n].interval_start > latest_alert_ts) {
                            latest_alert_ts = t10[n].interval_start;
                        }
                        if (n == t10.length - 1) {
                            if (u == "user") {
                                this.user_last_run_ts = latest_alert_ts - time_delay;
                            } else {
                                this.org_last_run_ts = latest_alert_ts - time_delay;
                            }
                        }
                    }

                    console.log("LATEST ALERT TS")
                    console.log(latest_alert_ts)
                }

                for (var n = 0; n < t10.length; n = n + 1) {

                    is_new = true;
                    try {
                        t10[n].asn_of_interest = t10[n].asn_of_interest.toString();
                    } catch (err) {
                        console.log(t10[n])
                    }

                    if (t10[n].non_direct_prefix == "null") {
                        t10[n].non_direct_prefix = "N/A";
                    }

                    if (t10[n].asn_of_interest == "99999999999") {
                        t10[n].asn_of_interest = "Restricted Prefix";
                    }

                    t10[n].alert_type = this.getAlertType(t10[n])

                    t10[n].dealt_with_t = false;

                    if (!this.asn_get_owner.includes(t10[n].asn_of_interest.toString())) {
                        this.asn_get_owner.push(t10[n].asn_of_interest);
                    }

                    if (!this.asn_get_owner.includes(t10[n].origin_asn_old.toString())) {
                        this.asn_get_owner.push(t10[n].origin_asn_old);
                    }
                    if (!this.asn_get_owner.includes(t10[n].origin_asn_new.toString())) {
                        this.asn_get_owner.push(t10[n].origin_asn_new);
                    }

                    t10[n].asn_of_interest = t10[n].asn_of_interest.toString();

                    var epochTime = t10[n].interval_start;
                    var dateTime = this.convertEpochtoTimeDate(epochTime);
                    t10[n].time_5min = epochTime;
                    t10[n].interval_start = dateTime;

                    
                    if (this.allow_popped) {
                        if (t10[n].time_5min >= latest_alert_ts) {
                            if (u == "user") {
                            this.user_recent_alerts.push({
                                prefix: t10[n].prefix,
                                origin_asn_new: t10[n].origin_asn_new,
                                origin_asn_old: t10[n].origin_asn_old,
                                time_5min: t10[n].time_5min,
                                asn_of_interest: t10[n].asn_of_interest,
                                controlled_prefix: t10[n].controlled_prefix
                            });
                            } else {
                            this.org_recent_alerts.push({
                                prefix: t10[n].prefix,
                                origin_asn_new: t10[n].origin_asn_new,
                                origin_asn_old: t10[n].origin_asn_old,
                                time_5min: t10[n].time_5min,
                                asn_of_interest: t10[n].asn_of_interest,
                                controlled_prefix: t10[n].controlled_prefix
                            });
                            }
                        }
                        
                        if (u == "user") {
                            if (
                                t10[n].asn_of_interest == "Restricted Prefix" &&
                                !Object.keys(this.user_prefixes).includes(
                                    t10[n].controlled_prefix
                                )
                            ) {
                                this.user_prefixes[t10[n].controlled_prefix] = {};
                            } else if (
                                !Object.keys(this.user_asns).includes(t10[n].asn_of_interest) &&
                                t10[n].asn_of_interest != "Restricted Prefix"
                            ) {
                            this.user_asns[t10[n].asn_of_interest] = {};
                            }
                        } else {
                            if (
                                t10[n].asn_of_interest == "Restricted Prefix" &&
                                !Object.keys(this.org_prefixes).includes(t10[n].controlled_prefix)
                            ) {
                                this.org_prefixes[t10[n].controlled_prefix] = {};
                            } else if (
                                !Object.keys(this.org_asns).includes(t10[n].asn_of_interest) &&
                                t10[n].asn_of_interest != "Restricted Prefix"
                            ) {
                            this.org_asns[t10[n].asn_of_interest] = {};
                            }
                        }
                    } else {
                        if (
                            t10[n].asn_of_interest == "Restricted Prefix" &&
                            !Object.keys(this.reviewed_prefixes).includes(
                                t10[n].controlled_prefix
                            )
                        ) {
                            this.reviewed_prefixes[t10[n].controlled_prefix] = {};
                        } else if (
                            !Object.keys(this.reviewed_asns).includes(t10[n].asn_of_interest) &&
                            t10[n].asn_of_interest != "Restricted Prefix"
                        ) {
                        this.reviewed_asns[t10[n].asn_of_interest] = {};
                        }
                    }

                    // we set the asn of interest to the restricted prefix for display purposes
                    if (t10[n].controlled_prefix != 'null' && t10[n].asn_of_interest == 'Restricted Prefix') {
                        t10[n].asn_of_interest = t10[n].controlled_prefix
                    }

                    if (this.allow_popped) {
                        // de-duplication
                        if (!(Object.keys(this.alert_keys).includes(t10[n].prefix))) {
                            this.alert_keys[t10[n].prefix] = {}
                        }
                        if (!(Object.keys(this.alert_keys[t10[n].prefix]).includes(t10[n].time_5min))) {
                            this.alert_keys[t10[n].prefix][t10[n].time_5min] = []
                        }
                        if (this.alert_keys[t10[n].prefix][t10[n].time_5min].includes((t10[n].origin_asn_old + "," + t10[n].origin_asn_new).toString())) {
                            is_new = false
                            //console.log("OLD ALERT")
                            //console.log(t10[n])
                            for (var j = 0 ; j < use_alerts.length ; j++ ) {
                                var currentAlert = use_alerts[j]
                                if (
                                    currentAlert.prefix == t10[n].prefix && 
                                    currentAlert.origin_asn_new == t10[n].origin_asn_new && 
                                    currentAlert.origin_asn_old == t10[n].origin_asn_old && 
                                    currentAlert.time_5min == t10[n].time_5min
                                ) {
                                    currentAlert.impact_score_mean = Math.max(currentAlert.impact_score_mean, t10[n].impact_score_mean)
                                    if (!(currentAlert.asn_of_interest.includes('/'))) {
                                        currentAlert.bonus_interest = currentAlert.asn_of_interest
                                        currentAlert.asn_of_interest = t10[n].asn_of_interest
                                        currentAlert.bonus_show = false
                                        //console.log(currentAlert)
                                    } else {
                                        currentAlert.bonus_interest = t10[n].asn_of_interest
                                        currentAlert.bonus_show = false
                                        //console.log(currentAlert)
                                    }
                                }
                            }
                        } else {
                            this.alert_keys[t10[n].prefix][t10[n].time_5min].push(
                                (t10[n].origin_asn_old + "," + t10[n].origin_asn_new).toString()
                            )
                        }
                    }

                    if (is_new) {
                        use_alerts.push(t10[n])
                    }

                    if (n == t10.length - 1) {
                        this.getASNOwners();
                    }
                }
                var d = new Date();
                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) ;
                this.updatedStr = "Last update: " + dateFormatted + " " + timeFormatted

                this.id = this.id + 1;
                if (this.allow_popped) {
                    if (u == "user") {
                        
                        this.load_user = false;
                        console.log("USER ASNS");
                        this.user_bubbledata = this.createBubbleDatasets('user')
                        this.filterAlerts('user', '', '')
                        
                    } else {
                        
                        this.load_org = false;
                        console.log("ORG ASNS");
                        this.org_bubbledata = this.createBubbleDatasets('organisation')
                        this.filterAlerts('organisation', '', '')
                        
                    }
                } else {
                    this.reviewed_bubbledata = this.createBubbleDatasets('dealt_with')
                    this.filterAlerts('reviewed', '', '')
                }
                this.loading = false;
            } catch (err) {
                if (this.allow_popped) {
                    if (u == "user") {
                        this.user_alerts = [];
                        this.filterAlerts('user', '', '')
                        this.load_user = false;
                        this.loading = false;
                    } else {
                        this.org_alerts = [];
                        this.filterAlerts('organisation', '', '')
                        this.load_org = false;
                        this.loading = false;
                    }
                } else {
                    this.reviewed_alerts = [];
                    this.filterAlerts('reviewed', '', '')
                    this.loading = false;
                    
                }
                console.log(err);
                var d = new Date();
                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) ;
                this.updatedStr = "Last update: " + dateFormatted + " " + timeFormatted
            }
        },
    
            
            
        viewBonus: async function (item) {
            item.bonus_show = !item.bonus_show
            this.table_buffer = false;
            this.$nextTick(() => {
                // Add the component back in
                this.table_buffer = true;
            });
        }, 
        getColor: function (indate) {
            let d_obj = new Date();
            let day = ("0" + d_obj.getUTCDate()).slice(-2);
            let mon = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
            let yr = d_obj.getUTCFullYear();
            let fdate = day + "/" + mon + "/" + yr;

            d_obj.setDate(d_obj.getUTCDate() - 1);
            let day2 = ("0" + d_obj.getUTCDate()).slice(-2);
            let mon2 = ("0" + (d_obj.getUTCMonth() + 1)).slice(-2);
            let yr2 = d_obj.getUTCFullYear();
            let yfdate = day2 + "/" + mon2 + "/" + yr2;

            if (fdate == indate) {
                return '#FF6347'
            } else if ( yfdate == indate ) {
                return '#FFDAB9'
            } else {
                return '#ffffff'
            }
        },
        changeOrderBy: function (order, type) {
            if (type == "user") {
                this.orderby = order
                this.pagination.sortBy = null
                this.pagination.descending = null
                this.top10Message = this.organisation + " Alerts"
                this.top10alertsUser('refresh', order)
            } else if (type == "global") {
                this.orderby = order
                this.pagination.sortBy = null
                this.pagination.descending = null
                this.top10Message = "Global episodes"
                this.top10alerts('refresh', order)
            }
            
        },
        excludeChange: function () {
            this.filterAlerts(
                this.filter_criteria.user,
                this.filter_criteria.prefix,
                this.filter_criteria.asn
            );
        },
        getAllUserAlerts: async function (n) {
            try {
                var usr=null
                if (this.overarching_type == "user") {
                    var usr = this.username;
                } else {
                    var usr = "whole_organisation";                    
                }
                this.showAllDownload = false;
                this.allUserAlerts = [];
                this.allLoading = true;
                this.allErrMsg = false;
                var query = `query top10 { getNotificationsForOrg (
                        page_offset: ` + (n * 1000) + `, 
                        page_rows: ` + ((n+1) * 1000) + `, 
                        order_by:"`+ this.orderby +`",
                        exclude_path_change: ` + !this.exclude_path_change + `,
                        exclude_first_seen: ` + !this.exclude_first_seen + `,
                        exclude_in_path: ` + !this.exclude_in_path + `,
                        exclude_own_assert: ` + !this.exclude_own_assert + `,
                        p_user: "` + usr + `"
                        ) {
                        prefix
                        origin_asn_new
                        origin_asn_old
                        interval_start
                        hijack_score_min
                        impact_score_min
                        hijack_score_max
                        impact_score_max
                        hijack_score_mean
                        impact_score_mean
                        asn_of_interest
                        validation
                        event_count
                        countdown
                        email_count
                        organisation_name
                        notified_organisation
                        asn_class
                        dealt_with
                        controlled_prefix
                        non_direct_prefix
                    }  
                }`;
                console.log(query)        
                const  allAlertsData  = await API.graphql(graphqlOperation(query));
                console.log(allAlertsData)
                var allAlerts = allAlertsData.data.getNotificationsForOrg
                console.log(allAlerts)
                if (allAlerts) {
                    if (allAlerts.length > 0 && allAlerts[0].asn_class != null) {
                        var urldata = window.location.origin + "/#/alertFromTop10/"

                        for (var n=0; n< allAlerts.length; n=n+1) {

                            if (allAlerts[n].asn_of_interest == '99999999999') {
                                allAlerts[n].asn_of_interest = 'Restricted Prefix';
                            }

                            allAlerts[n].alert_url = urldata + allAlerts[n].prefix.replace("/", "%2F") + "~" + allAlerts[n].origin_asn_old + "~" + allAlerts[n].origin_asn_new + "~" + allAlerts[n].interval_start
                        
                            var epochTime = allAlerts[n].interval_start
                            var dateTime = this.convertEpochtoTimeDate(epochTime);
                            allAlerts[n].time_5min = epochTime
                            allAlerts[n].interval_start  = dateTime.date + dateTime.time;
                        }
                        this.allUserAlerts = allAlerts;
                        this.allLoading = false;
                        this.showAllDownload = true; 
                    } else {
                        if (n > 0) {
                            this.allErrMsg = "No additional alerts"
                            this.allLoading = false;
                            if (n == 1) {
                                this.downloadStr = "1000 most recent alerts";
                                this.allRound = 0;
                            } else {
                                this.allRound += -1;
                                this.downloadStr = "alerts " + (1000 * this.allRound) + " to " + (1000* (this.allRound + 1));
                            }
                        } else {
                            this.allErrMsg = "No alerts"
                            this.allLoading = false;
                        }
                    }
                    if (allAlerts.length > 999) {
                        this.allRound += 1
                        this.oldDownStr = this.downloadStr;
                        this.downloadStr = "alerts " + (1000 * this.allRound) + " to " + (1000* (this.allRound + 1));
                    }
                    
                } else {
                    this.allUserAlerts = false
                    this.allErrMsg = "No alerts"
                    this.allLoading = false;
                    
                }
                        
            } catch (err) {
                this.allUserAlerts = false
                console.log(err)
                this.allErrMsg = "Error pulling all alerts"
                this.allLoading = false;
            }
        },
        getAnASNOwner: async function(asn) {
            if (asn == 0 || asn == 'N/A') {
                return "None";
            } else if (asn == 'Restricted Prefix') {
                return "Restricted Prefix"
            } else {
                try {
                    var qry = `query getASNOwner { getASNOwner ( asn: "` +
                    asn +
                    `" ) {
                            organisation
                        }
                    }`;
                    //console.log(qry);
                    const res = await API.graphql(graphqlOperation(qry));
                    var ownData = res.data.getASNOwner;
                    //console.log(ownData);
                    if (ownData) {
                        if (ownData.length > 0) {
                        //console.log("owner: ");
                        //console.log(ownData[0].organisation);
                            if (ownData[0].organisation) {
                                return ownData[0].organisation;
                            } else {
                                return "Unknown";
                            }
                        } else {
                            return "Unknown";
                        }
                    } else {
                        return "Unknown";
                    }
                } catch (err) {
                    console.log(err);
                    return "Unknown";
                }
            }
        },
        getASNOwners: async function () {
            
            console.log("gettign asn owners")
            var nero = {}
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                var keys = Object.keys(this.asn_own_dict)
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    nero[this.asn_get_owner[i]] = this.getAnASNOwner(this.asn_get_owner[i])
                }
            }
            for ( var i = 0 ; i < this.asn_get_owner.length ; i++ ) {
                
                
                //console.log("GETTING AN OWNER")
                if (!(keys.includes((this.asn_get_owner[i]).toString()))) {
                    this.asn_own_dict[this.asn_get_owner[i]] = await nero[this.asn_get_owner[i]]
                }
                
                if ( i == this.asn_get_owner.length - 1 ) {
                    //console.log("UPDATETICKER")
                    this.is_asn_owners = false
                    this.$nextTick(() => {
                        // Add the component back in
                        this.is_asn_owners = true;
                    });
                    this.table_buffer = false;
                    this.$nextTick(() => {
                        // Add the component back in
                        this.table_buffer = true;
                    });
                }
            }
        },
        tagDealtWith: async function (entry, tag) {
            entry.dealt_with = tag
            if (this.overarching_type == 'user') {
                var use_alerts = this.user_alerts
            } else {
                var use_alerts = this.org_alerts
            }
            //console.log(entry)
            //console.log(tag)
            if ( tag == 1 ) {
                if ( entry.asn_of_interest.includes('/') ) {
                    this.to_be_dealt.push({
                        prefix: entry.prefix,
                        origin_asn_new: entry.origin_asn_new,
                        origin_asn_old: entry.origin_asn_old,
                        time_5min: entry.time_5min,
                        asn_of_interest: 99999999999,
                        notified_organisation: entry.notified_organisation,
                        user: entry.user,
                        pos: use_alerts.indexOf(entry)
                    })
                } else {
                    this.to_be_dealt.push({
                        prefix: entry.prefix,
                        origin_asn_new: entry.origin_asn_new,
                        origin_asn_old: entry.origin_asn_old,
                        time_5min: entry.time_5min,
                        asn_of_interest: entry.asn_of_interest,
                        notified_organisation: entry.notified_organisation,
                        user: entry.user,
                        pos: use_alerts.indexOf(entry)
                    })
                }
                
            } else {
                for ( var i = 0 ; i < this.to_be_dealt.length ; i++ ) {
                    if ( this.to_be_dealt[i].prefix == entry.prefix &&
                        this.to_be_dealt[i].origin_asn_new == entry.origin_asn_new &&
                        this.to_be_dealt[i].origin_asn_old == entry.origin_asn_old &&
                        this.to_be_dealt[i].time_5min == entry.time_5min &&
                        this.to_be_dealt[i].asn_of_interest == entry.asn_of_interest &&
                        this.to_be_dealt[i].notified_organisation == entry.notified_organisation &&
                        this.to_be_dealt[i].user == entry.user
                    ) {
                        this.to_be_dealt.splice( i , 1 )
                        i -= 1
                    }
                }
            }
            if ( this.to_be_dealt.length > 0 ) {
                this.allow_dealt = true
            } else {
                this.allow_dealt = false
            }

        },
        updateDealtWithMany: async function (dealt_w) {
            // (`prefix`, origin_asn_new, origin_asn_old, time_5min, asn_of_interest, organisation_name, `user`)
            var sendings = []
            var to_go = []
            if ( this.show_popped != '' ) {
                dealt_w = 0
            }

            if (this.overarching_type == 'user') {
                var use_alerts = this.user_alerts
            } else {
                var use_alerts = this.org_alerts
            }

            for ( var i = 0 ; i < this.to_be_dealt.length ; i++ ) {
                var entry = this.to_be_dealt[i]
                sendings.push(
                    String.raw`(\"` + entry.prefix + String.raw`\",`
                    + entry.origin_asn_new + `,` 
                    + entry.origin_asn_old + `,` 
                    + entry.time_5min + `,` 
                    + entry.asn_of_interest + `,` 
                    + String.raw`\"` + entry.notified_organisation + String.raw`\",\"` 
                    + entry.user + String.raw`\")`
                )
                to_go.push(entry.pos)
            }
            var sendstr = sendings.join(",")
            try {
                var query = `query getUpdateDealtWithMany { 
                    getUpdateDealtWithMany (
                        update_str: "` + sendstr + `", 
                        p_dealt_with: ` + dealt_w + `
                    )
                    {
                        ts
                    }  
                }`;
                console.log(query) 
                const updata = await API.graphql(graphqlOperation(query));
                //console.log(updata)
                var updated = updata.data.getUpdateDealtWithMany
                if ( parseInt(updated[0].ts) == 1 ) {
                    console.log("updated successfully")
                }
            } catch (err) {
                console.log(err)
            }
            to_go.sort()
            //console.log(to_go)
            for ( var i = this.to_be_dealt.length - 1 ; i > -1 ; i-- ) {
                //console.log(to_go[i])
                use_alerts.splice(to_go[i], 1)
            }
            this.excludeChange();
            this.to_be_dealt = []
            this.allow_dealt = false
            this.new_updated = true
        },
        showPoppedAlerts: async function () {
            console.log("Showing REVIEWED Alerts")
            this.show_popped = ", p_dealt_with: 1 "
            this.allow_popped = false
            
            this.top10alerts(this.overarching_type)
            
        },
        showUnpoppedAlerts: async function () {
            console.log("Showing Live Alerts")
            this.show_popped = ""
            this.allow_popped = true
            if (this.overarching_type == "user") {
                
                this.load_user = false;
                console.log("USER ASNS");
                this.user_bubbledata = this.createBubbleDatasets('user')
                this.filterAlerts('user', '', '')
                
            } else {
                
                this.load_org = false;
                console.log("ORG ASNS");
                this.org_bubbledata = this.createBubbleDatasets('organisation')
                this.filterAlerts('organisation', '', '')
                
            }
        },
        getAlertType: function (alert) {
            /* if (alert.asn_of_interest == 'Restricted Prefix') {
                return 'Restricted Prefix'
            } else */
            if (alert.origin_asn_old == '0' || alert.origin_asn_old == 0) {
                return 'First Seen Prefix'
            } else if (alert.origin_asn_new == alert.origin_asn_old) {
                return 'Path Change'
            } else {
                if (alert.non_direct_prefix == 'N/A' || !alert.non_direct_prefix) {
                    return 'Ownership Assertion'
                } else {
                    var nd_cidr = parseInt(alert.non_direct_prefix.split("/")[1])
                    var cidr = parseInt(alert.prefix.split("/")[1])
                    if (nd_cidr > cidr) {
                        return 'Super-ownership Assertion'
                    } else {
                        return 'Sub-ownership Assertion'
                    }

                }
            }
        },
        clickHandler: function (prefix, old_asn, new_asn, timeEpoch) {
            var paramatersCombined = prefix+"~"+old_asn+"~"+new_asn+"~"+timeEpoch
            let routeData = this.$router.resolve({name: 'Alert From Top 10', params: {prefix: paramatersCombined}});
            window.open(routeData.href, '_blank');
            //this.$router.push({ name: 'Alert From Top 10', 
            //                                params: {prefix: paramatersCombined}})
        },
        clickHandleAlert: async function(selectedAlertFromTable) {
            console.log(selectedAlertFromTable)
            if (selectedAlertFromTable.asn_of_interest == 'Dummy') {    
                var paramatersCombined =
                    selectedAlertFromTable.prefix +
                    "~" +
                    selectedAlertFromTable.origin_asn_old +
                    "~" +
                    selectedAlertFromTable.origin_asn_new +
                    "~" +
                    selectedAlertFromTable.time_5min +
                    "~D"
                let routeData = this.$router.resolve({
                    name: "Alert From Top 10",
                    params: { prefix: paramatersCombined, dummy: true }
                });
                window.open(routeData.href, "_blank");
            } else {
                var paramatersCombined =
                    selectedAlertFromTable.prefix +
                    "~" +
                    selectedAlertFromTable.origin_asn_old +
                    "~" +
                    selectedAlertFromTable.origin_asn_new +
                    "~" +
                    selectedAlertFromTable.time_5min;
                let routeData = this.$router.resolve({
                    name: "Alert From Top 10",
                    params: { prefix: paramatersCombined }
                });
                window.open(routeData.href, "_blank");
            }
        },
        isEmpty: function(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        },
        convertEpochtoTimeDate: function (epochTime) {
            try {
                var d = new Date( epochTime *1000);

                var day = ("0" + d.getUTCDate()).slice(-2);
                var month = ("0"+(d.getUTCMonth()+1)).slice(-2)
                var year = d.getUTCFullYear()
                var dateFormatted = day + "/" + month + "/" + year
                var timeFormatted = ("0" + d.getUTCHours()).slice(-2) + ":" + ("0" + d.getUTCMinutes()).slice(-2);

                var dateTime  = {"date": dateFormatted, "time": timeFormatted}

                return dateTime
            }
            catch(err) {
                console.log(err)
            }

        }
    },
    watch: {
        showbubble (n) {
            this.$store.commit("setShowSettings", { 'showBubble': n });
        },
        autoMerge(n) {
            this.$store.commit("setShowSettings", {
                'autoMerge': n
            })
            if (this.autoMerge) {
                this.mergeAlerts(this.overarching_type)
            }
        },
        showUserTen(n) {
            if (n==true) {
                if (this.overarching_type == 'user') {
                    this.top10Message = this.username + " Alerts"
                    this.colorpick = this.colors[2]
                } else {
                    this.top10Message = this.organisation + " Alerts"
                    this.colorpick = this.colors[1]
                }
                    
                this.useHeaders = this.headers
                this.top10alerts(this.overarching_type);
                
                this.$emit('changeAlerts',  this.showUserTen)
            } else {
                this.top10Message = "Global episodes"
                this.useHeaders = this.headersGlobal
                this.top10alerts('refresh');
                this.colorpick = this.colors[0]
                this.$emit('changeAlerts',  this.showUserTen)
            }
        },     
        exclude_first_seen(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcFirst", n);
            }
            
            console.log("changing first seen")
            console.log(this.$store.state.alertsExcFirst)
        },
        exclude_path_change(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcPath", n);
            }
            console.log("changing path change")
            console.log(this.$store.state.alertsExcPath)
        },
        exclude_in_path(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcInPath", n);
            }
            console.log("changing in path")
            console.log(this.$store.state.alertsExcInPath)
        },
        exclude_own_assert(n) {
            if (this.allowExcludeSwitches) {
                this.$store.commit("setAlertsExcOwnAssert", n);
            }
            console.log("changing in path")
            console.log(this.$store.state.alertsExcInPath)
        }

    }
    
};

</script>

<style scoped>
    
    .v-input__slot {
        align-items: center;
        justify-content: center;
    }

    table.v-table tbody td:first-child, 
    table.v-table tbody td:not(:first-child), 
    table.v-table tbody th:first-child, 
    table.v-table tbody th:not(:first-child), 
    table.v-table thead td:first-child, 
    table.v-table thead td:not(:first-child), 
    table.v-table thead th:first-child, 
    table.v-table thead th:not(:first-child) {
        padding: 0 5px
    }

    table.v-table tbody td, 
    table.v-table tbody th {
        height: 38px;
    }

    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }

    .v-table tr:hover:not(.v-table__expanded__content) {
        background-color: rgba(0, 0, 0, .4);
    }

    .special
    {
        cursor: pointer;
    }

</style>